import * as Action from '../actions';

const initialState = {
  simpleForm: null,
  isFetchingData: false,
  fetchchatpatient: null,
  checkemptyrequest: null,
  users: null,
  userResponse: null,
  patient: null,
  isLoadingChat: false,
};

const emptyerror = {
  msg: 'Please fill at least one field to search',
};

const patients = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case Action.FETCH_PATIENT_FOR_CHAT:
        return {
          ...state,
          fetchchatpatient: { ...action.payload.param },
          patient: { ...action.payload.param },
          checkemptyrequest: null,
          simpleForm: [],
        };

      case Action.FETCH_PATIENT_DATA_REQUEST:
        return {
          ...state,
          isFetchingData: true,
          checkemptyrequest: null,
        };

      case Action.FETCH_PATIENT_DATA_SUCCESS:
        return {
          ...state,
          simpleForm: action.payload,
          checkemptyrequest: null,
          isFetchingData: false,
        };

      case Action.FETCH_PATIENT_DATA_FAILURE:
        return {
          ...initialState,
          simpleForm: action.payload,
          checkemptyrequest: null,
          isFetchingData: false,
        };

      /***** Get users  start****/
      case Action.CHECK_USER_DATA_REQUEST:
      case Action.SIGNUP_USER_DATA_REQUEST:
        return {
          ...state,
          isFetchingData: false,
          checkemptyrequest: null,
        };

      case Action.CHECK_USER_DATA_SUCCESS:
      case Action.CHECK_USER_DATA_FAILURE:
        return {
          ...state,
          users: action.payload,
          checkemptyrequest: null,
          isFetchingData: false,
        };

      /***** Get users  end****/
      case Action.FETCH_PATIENT_DATA_EMPTY:
        return {
          ...state,
          checkemptyrequest: emptyerror,
          isFetchingData: false,
        };

      /***** Signup User  start****/

      case Action.SIGNUP_USER_DATA_SUCCESS:
      case Action.SIGNUP_USER_DATA_FAILURE:
        return {
          ...state,
          userResponse: action.payload,
          checkemptyrequest: null,
          isFetchingData: false,
        };

      /***** Signup User  end****/

      /***** Add patient  start****/
      case Action.ADD_PATIENT_DATA_REQUEST:
        return {
          ...state,
          isLoadingChat: true,
          checkemptyrequest: null,
        };

      case Action.ADD_PATIENT_DATA_SUCCESS:
        return {
          ...state,
          patient: action.payload.data,
          patientMessage: action.payload.message,
          claimedFlag: action.payload.claimed,
          checkemptyrequest: null,
          isLoadingChat: false,
        };

      case Action.ADD_PATIENT_DATA_FAILURE:
        return {
          ...state,
          patient: action.payload,
          checkemptyrequest: null,
          isLoadingChat: false,
        };

      /***** Add patient  end****/
      default:
        return state;
    }
  }
};

export default patients;
